export class AppSettings {
    public static BTCAPIAddress() {
        if (location.hostname === "btc.localhost") // On Dev?
            return "https://" + location.hostname + ":7089";
        else
            return "https://" + location.hostname;
    }
}
